import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

import { useSetScroll } from "~franchise-website/states";
import ReviewsImage from "../ReviewsImage/ReviewsImage";

const Hero = () => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up("md"), {
		defaultMatches: true,
	});

	const setScroll = useSetScroll();

	return (
		<Grid
			container
			spacing={4}>
			<Grid
				item
				container
				xs={12}
				md={6}
				className={isMd ? "" : "centerTextMobile"}>
				<Box>
					<Typography
						sx={{
							textTransform: "uppercase",
							fontWeight: "medium",
							fontSize: "1.5rem",
						}}
						gutterBottom
						color="secondary">
						Franchise Territory Mapping
					</Typography>
					<Box marginBottom={2}>
						<Typography
							variant="h2"
							color="textPrimary"
							sx={{
								fontWeight: 700,
							}}>
							Sell more franchises
							<br />
							<Typography
								color="primary"
								component="span"
								variant="inherit">
								in 90 days
								<br />
							</Typography>
						</Typography>
					</Box>
					<Box marginBottom={3}>
						<Typography
							variant="h6"
							component="p"
							color="textSecondary">
							We help franchise businesses sell more territories, by giving them
							the expert assistance they need to succeed.
						</Typography>
					</Box>
					<Button
						sx={{ width: "220px" }}
						variant="contained"
						color="primary"
						component="a"
						onClick={() => setScroll(true)}
						target="blank"
						size="large">
						Request pricing
					</Button>
				</Box>
			</Grid>
			<Grid
				item
				xs={12}
				md={6}>
				<ReviewsImage />
			</Grid>
		</Grid>
	);
};

export default Hero;
